module.exports = __webpack_public_path__ + "img/placeholder.c8ba2a24.jpg";